module.exports = __webpack_public_path__ + "z/proximanova-light-webfont.2fa97428.svg";